import React, { useEffect, useState } from "react";
import { listJobs, getJob } from "../api/jobs";

export default function JobsPage() {
    const [jobs, setJobs] = useState([]);
    const [err, setErr] = useState("");

    const load = async () => {
        try {
            setErr("");

            const data = await listJobs();

            // 서버가 배열로 주거나 {items:[]}로 주거나 둘 다 대응
            const arr = Array.isArray(data) ? data : (data?.items || []);

            // jobId/id/job_id 중 하나로 통일
            const normalized = arr.map((j) => ({
                ...j,
                jobId: j.jobId || j.id || j.job_id || "",
                status: j.status || "UNKNOWN",
                progress: typeof j.progress === "number" ? j.progress : 0,
            }));

            setJobs(normalized);
        } catch (e) {
            setErr(e?.message || String(e));
        }
    };

    useEffect(() => {
        load();

        // 3초 폴링 (상업용 MVP)
        const t = setInterval(() => load(), 3000);
        return () => clearInterval(t);
    }, []);

    const refreshOne = async (jobId) => {
        try {
            const j = await getJob(jobId);

            const normalized = {
                ...j,
                jobId: j.jobId || j.id || j.job_id || jobId,
                status: j.status || "UNKNOWN",
                progress: typeof j.progress === "number" ? j.progress : 0,
            };

            setJobs((prev) =>
                prev.map((x) => (x.jobId === jobId ? normalized : x))
            );
        } catch (e) {
            console.warn("refreshOne failed", e);
        }
    };

    return (
        <div style={{ maxWidth: 1000, margin: "40px auto", padding: "0 16px" }}>
            <h1 style={{ fontSize: 32, marginBottom: 12 }}>Jobs</h1>

            {err && (
                <div style={{ padding: 12, background: "#fee2e2", marginBottom: 12 }}>
                    오류: {err}
                </div>
            )}

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                <tr style={{ borderBottom: "1px solid #ddd" }}>
                    <th align="left">Job ID</th>
                    <th align="left">Status</th>
                    <th align="left">Progress</th>
                    <th align="left">Created</th>
                    <th />
                </tr>
                </thead>

                <tbody>
                {jobs.map((j) => (
                    <tr key={j.jobId} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ padding: 8, fontFamily: "monospace" }}>
                            {j.jobId || "(unknown)"}
                        </td>

                        <td style={{ padding: 8 }}>{j.status}</td>

                        <td style={{ padding: 8, width: 160 }}>
                            <div
                                style={{
                                    background: "#eee",
                                    height: 8,
                                    borderRadius: 4,
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        width: `${j.progress || 0}%`,
                                        height: "100%",
                                        background: "#111827",
                                    }}
                                />
                            </div>
                            <div style={{ fontSize: 12 }}>
                                {j.progress || 0}%
                            </div>
                        </td>

                        <td style={{ padding: 8 }}>
                            {j.createdAt || j.created_at || ""}
                        </td>

                        <td style={{ padding: 8 }}>
                            <button onClick={() => refreshOne(j.jobId)}>새로고침</button>
                        </td>
                    </tr>
                ))}

                {jobs.length === 0 && (
                    <tr>
                        <td colSpan={5} style={{ padding: 16, textAlign: "center" }}>
                            등록된 Job이 없습니다.
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
}
